import { countriesConfig, getAsCountryISO2, isCountryISO2 } from '@lib/shared';
import type { CountryConfig } from '@lib/shared';
import lodashSortBy from 'lodash-es/sortBy';
import type { ComputedRef } from 'vue';

import { Locale } from '~i18n/i18nConfig';

export type CountryOption = Pick<CountryConfig, 'rootIddCode' | 'taxIdMandatory'> & {
    countryCode: string;
    label: string;
};

export interface UseCountriesReturnType {
    countries: ComputedRef<CountryOption[]>;
    getLocalizedCountry: (countryCode: string) => string | null;
}

export const useCountries = (): UseCountriesReturnType => {
    const { locale } = useI18n();

    const getLocalizedCountry: UseCountriesReturnType['getLocalizedCountry'] = countryCode =>
        isCountryISO2(countryCode) ? countriesConfig[getAsCountryISO2(countryCode)].i18nNames[locale.value] : null;

    return {
        countries: computed<CountryOption[]>(() =>
            lodashSortBy(
                Object.entries(countriesConfig).map(([countryCode, { i18nNames, rootIddCode, taxIdMandatory }]: [string, CountryConfig]) => ({
                    taxIdMandatory,
                    rootIddCode,
                    countryCode,
                    label: i18nNames[locale.value as Locale],
                })),
                ['label']
            )
        ),

        getLocalizedCountry,
    };
};
